export default __webpack_public_path__ + "assets/images/4.fa2e29.png";